import { Box, Button, Flex, Heading, HStack, IconButton, Image } from '@chakra-ui/react'
import React, { useState } from 'react'
import NavItems from './NavItems'
import { useColorModeValue } from '../ui/color-mode'
import { LuMenu } from 'react-icons/lu'
import NavbarDrawer from './NavbarDrawer'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'


const Navbar = ({displayBorder =false, globalColor= 'purple'}) => {

    
    
    const { t, i18n } = useTranslation();
    const [language, setLanguage] = useState('fr');

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setLanguage(lng)
    };
    const location = useLocation();

    const navItems = [
        {
            label : t('navitem1'),
            href: '/'
        },
        {
            label : t('navitem3'),
            href: location.pathname === '/' ? '#our-services' : '/#our-services'
        },
        {
            label : t('navitem4'),
            href: location.pathname === '/' ? '#our-collaborations' : '/#our-collaborations'
        },
        {
            label : t('navitem5'),
            href: location.pathname === '/' ? '#our-location' : '/#our-location'
        },
    ]



    const cardColor = useColorModeValue('white', 'black')
    const [showNavbarBorder, setShowNavbarBorder] = useState(false);
    let isIOSDevice = !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent); // fails on iPad iOS 13


    React.useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 10) {
                setShowNavbarBorder(true);
            } else {
                setShowNavbarBorder(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

  return (
    <Box px={{'2xl': '19%', md: '10%', base: 1}} borderBottom={(showNavbarBorder || displayBorder) && "1px solid"} borderColor={useColorModeValue('gray.100', 'gray.800')}  
    bgColor={cardColor} 
    //bgColor={cardColor}
    backdropFilter="blur(10px)"  >
        {/* desktop */}

        <Flex justify={{md: 'inherit', base: 'space-between'}} minH={{'2xl': '70px', base: isIOSDevice ? '70px' : '60px'}} align={'center'}>

            {/* logo */}
            <HStack gap={1}>
                <NavbarDrawer navItems={navItems}>
                    <IconButton display={{md: 'none', base: 'inline-flex'}} variant={'ghost'}>
                        <LuMenu/>
                    </IconButton>
                </NavbarDrawer>
                <Image
                    w={{'2xl': '130px', base: '100px'}}
                    src={require('../../assets/logo.png')}
                 />
            </HStack>

            {/* navItems */}
            <Flex display={{md: 'flex', base: 'none'}} gap={7} flex={1} justify={'center'}>
                {navItems.map((elt, index)=>{
                    return <NavItems globalColor={globalColor}  key={index} data={elt} />
                })}

            </Flex>

            {/* Call to Action */}
            <HStack position={'relative'} _before={{
                content: "''",
                h: {md: '28px', base: '18px'},
                w: '1px',
                position: 'absolute',
                zIndex: 4,
                left: -2,
                bgColor:  useColorModeValue('gray.400', 'white')
            }}>
                <Button fontWeight={600} size={'xs'} rounded={'full'} variant={'ghost'} onClick={() => changeLanguage(language === 'fr' ? 'en' : 'fr')}>
                    {language === 'fr' ? 'EN' : 'FR'}
                </Button>
                {/* <Button colorPalette={globalColor} display={{md: 'inline-flex', base: 'none'}} fontWeight={'medium'} variant={'ghost'} rounded={'full'}>
                    {t('support')}
                </Button> */}
                <Button 
                data-cal-namespace="30min"
                data-cal-link="support-escrutin/30min"
                data-cal-config='{"layout":"month_view","useSlotsViewOnSmallScreen":"true"}'
                colorPalette={globalColor} display={{md: 'inline-flex', base: 'none'}} fontWeight={'medium'} variant={'surface'} rounded={'full'}>
                    {t('navbarCallToAction')}
                </Button>
            
            </HStack>

        </Flex>
    </Box>
  )
}

export default Navbar
